import { de, enUS, es, fr, it, pt, ptBR } from "date-fns/locale";
/**
 * The one place an `AppLocale` becomes a date-fns locale (plan D27). Every
 * formatter in this folder takes the `AppLocale` as a parameter — the screen
 * reads it from the locale store — so nothing here hard-codes a language.
 *
 * date-fns names European Portuguese `pt` and has one Spanish, `es`, which is
 * what `es-419` reads (`D267`): month and weekday names are the same across
 * Latin America and Spain.
 */
const DATE_FNS_LOCALES = {
    "en-US": enUS,
    "pt-BR": ptBR,
    "es-419": es,
    "pt-PT": pt,
    "fr-FR": fr,
    "de-DE": de,
    "it-IT": it,
};
export function dateFnsLocale(locale) {
    return DATE_FNS_LOCALES[locale];
}
//# sourceMappingURL=locale.js.map